import { render, staticRenderFns } from "./DistributionCard.vue?vue&type=template&id=233ca7cc&"
import script from "./DistributionCard.vue?vue&type=script&lang=js&"
export * from "./DistributionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports